import { Link } from "gatsby";
import PropTypes from "prop-types";
import React from "react";
import SiteMargins from "./SiteMargins";
import styled from "styled-components";

const NavHeader = styled.nav`
  // padding-top: 0.8rem;
  padding-bottom: 0.8rem;
`;

const SiteTitle = styled.h1`
  font-size: 24px;
  font-weight: normal;
  text-align: right;

  a:visited {
    color: #e30000;
  }
`;

const Header = ({ siteTitle }) => (
  <NavHeader>
    <SiteMargins>
      <SiteTitle>
        <Link to="/">{siteTitle}</Link>
      </SiteTitle>
    </SiteMargins>
  </NavHeader>
);

Header.propTypes = {
  siteTitle: PropTypes.string,
};

Header.defaultProps = {
  siteTitle: ``,
};

export default Header;
